import { render } from "./LeafAngle.vue?vue&type=template&id=85536ae2&scoped=true"
import script from "./LeafAngle.vue?vue&type=script&lang=js"
export * from "./LeafAngle.vue?vue&type=script&lang=js"

import "./LeafAngle.vue?vue&type=style&index=0&id=85536ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85536ae2"]])

export default __exports__